import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { useAuth } from "@clerk/clerk-react";
import { createCheckout } from "../lib/api";

export default function Upgrade() {
  const { isSignedIn } = useAuth();
  const [billingPeriod, setBillingPeriod] = useState<"monthly" | "annual">("annual");

  const checkoutMut = useMutation({
    mutationFn: () => createCheckout(billingPeriod),
    onSuccess: ({ url }) => { window.location.href = url; },
  });

  return (
    <div style={{ minHeight: "100vh" }}>

      <div style={{ maxWidth: 680, margin: "0 auto", padding: "64px 24px", textAlign: "center" }}>
        <h1 style={{ fontSize: "clamp(28px, 5vw, 44px)", fontWeight: 800, margin: "0 0 16px", color: "#EFF2F5", letterSpacing: "-0.02em" }}>
          WorldRTT Pro
        </h1>
        <p style={{ fontSize: 18, color: "#98A1AB", margin: "0 0 44px", lineHeight: 1.6 }}>
          Scheduled monitoring, latency alerts, and a global dashboard — for the price of two coffees a month.
        </p>

        {/* Billing toggle */}
        <div style={{
          display: "inline-flex", margin: "0 auto 36px",
          background: "rgba(255,255,255,0.04)",
          borderRadius: 3, overflow: "hidden",
          border: "1px solid rgba(255,255,255,0.10)",
        }}>
          {(["monthly", "annual"] as const).map((p) => (
            <button
              key={p}
              onClick={() => setBillingPeriod(p)}
              style={{
                padding: "10px 28px",
                border: "none",
                background: billingPeriod === p ? "rgba(255,37,102,0.15)" : "transparent",
                color: billingPeriod === p ? "#EFF2F5" : "#98A1AB",
                fontSize: 14,
                fontWeight: 600,
                cursor: "pointer",
                transition: "background 0.15s, color 0.15s",
                fontFamily: "inherit",
              }}
            >
              {p === "monthly" ? "Monthly" : "Annual"}
              {p === "annual" && (
                <span style={{ marginLeft: 6, fontSize: 11, background: "rgba(255,37,102,0.15)", color: "#FF2566", padding: "2px 7px", borderRadius: 3 }}>
                  Save 31%
                </span>
              )}
            </button>
          ))}
        </div>

        {/* Pricing card */}
        <div className="glass" style={{ padding: "36px 40px", marginBottom: 32, border: "1px solid rgba(255,37,102,0.3)", borderTop: "2px solid #FF2566" }}>
          <div style={{ fontSize: 52, fontWeight: 800, color: "#EFF2F5", marginBottom: 4, letterSpacing: "-0.03em" }}>
            {billingPeriod === "monthly" ? "$12" : "$8.25"}
            <span style={{ fontSize: 18, fontWeight: 400, color: "#98A1AB" }}>/month</span>
          </div>
          {billingPeriod === "annual" && (
            <p style={{ margin: "0 0 28px", color: "#98A1AB", fontSize: 14 }}>$99/year, billed annually</p>
          )}

          <ul style={{ listStyle: "none", margin: "0 0 32px", padding: 0, textAlign: "left", display: "flex", flexDirection: "column", gap: 12 }}>
            {[
              "Up to 20 monitored endpoints",
              "1-minute minimum poll interval",
              "10 global probe regions",
              "P50/P95/P99 latency charts",
              "90-day uptime tracking",
              "Email & webhook alerts",
              "POST probes with custom headers",
              "Shareable result links",
              "No ads, no limits on on-demand probes",
            ].map((f) => (
              <li key={f} style={{ display: "flex", gap: 10, alignItems: "flex-start", fontSize: 15, color: "#EFF2F5" }}>
                <span style={{ color: "#39D98A", fontWeight: 700, flexShrink: 0 }}>✓</span>
                {f}
              </li>
            ))}
          </ul>

          {isSignedIn ? (
            <button
              onClick={() => checkoutMut.mutate()}
              disabled={checkoutMut.isPending}
              className="btn-primary"
              style={{ width: "100%", padding: "14px 0", fontSize: 16 }}
            >
              {checkoutMut.isPending ? "Redirecting to Stripe…" : "Start Pro"}
            </button>
          ) : (
            <a
              href={`/sign-up?redirect_url=/checkout`}
              className="btn-primary"
              style={{ display: "block", padding: "14px 0", fontSize: 16, textAlign: "center" }}
            >
              Sign up & start Pro
            </a>
          )}

          {checkoutMut.error && (
            <p style={{ color: "#FF5C5C", fontSize: 13, marginTop: 12 }}>
              {checkoutMut.error instanceof Error ? checkoutMut.error.message : "Something went wrong"}
            </p>
          )}
        </div>

        <p style={{ fontSize: 13, color: "#98A1AB" }}>
          Secure payment via Stripe · Cancel anytime via the billing portal
        </p>
      </div>
    </div>
  );
}
